module.exports = __webpack_public_path__ + "img/1alB-p-Laxup.9733a8cd.jpg";